import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActivityCenterBell",
  props: {
    status: {
      type: String,
      // required: true, TODO: remove when done
      default: "clear",
      validator: function (value) {
        const validStatuses = ["past-due", "active", "upcoming", "planned", "clear"];
        return _includesInstanceProperty(validStatuses).call(validStatuses, value);
      }
    },
    badgeCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusMap() {
      return {
        "past-due": "text-danger",
        active: "text-success",
        upcoming: "text-gray mid-opacity",
        planned: "text-gray mid-opacity",
        clear: ""
      };
    },
    bellClass() {
      const bellClass = ["ignore-popover"];
      bellClass.push(this.status === "clear" ? "fa-bell-o" : "fa-bell");
      if (this.badgeCount > 0) bellClass.push("has-badge");
      return bellClass.join(" ");
    },
    colorClass() {
      return this.statusMap[this.status];
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
});